export default "__VITE_ASSET__epGf3Pz0__"